import context from '@/context'
import DashboardList from '@/components/dashboard/settings/list'
import getComponentKey from '@/utils/getComponentKey'
import Icon from '@/components/Icon'
import React, { useReducer } from 'react'
import Resx from '@/components/Resx'
import { Button } from 'reactstrap'
import { dialogTypes } from '@/dialogs'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import { useDialog } from '@/hooks/useDialog'
import { useLocalization } from '@/hooks/localization'
import { format } from '@/utils/StringUtilities'

const initialState = {
  componentKey: getComponentKey(),
  fetching: false,
  updating: false,
  canAddWidget: true
}

const actionTypes = {
  Fetching: 'dashboard/fetching',
  Fetched: 'dashboard/fetched',
  Updating: 'dashboard/updating',
  Updated: 'dashboard/updated',
  Error: 'dashboard/error'
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, canAddWidget: action.data.canAddWidget }
    case actionTypes.Updating: return { ...state, updating: true }
    case actionTypes.Updated: return { ...state, updating: false, componentKey: getComponentKey() }
    case actionTypes.Error: return { ...state, updating: false, fetching: false, componentKey: getComponentKey() }
    default: return state
  }
}

const DashboardSettings = ({ enumName }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { localize } = useLocalization()
  const openDialog = useDialog()

  const validate = (value) => {
    return value < 1 || value > 100
      ? format(localize('Validations.MinMaxValue'), 1, 100) : null
  }
  const showError = (err) => {
    openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Error',
      localizedContent: err
    })
  }

  const saveDashboardItem = (input) => {
    dispatch({ type: actionTypes.Updating })
    saveDashboardItemSilent(input)
      .then(() => {
        dispatch({ type: actionTypes.Updated })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  }

  const saveDashboardItemSilent = async (input) => {
    const validationResult = validate(input.rowsCount)
    if (validationResult) {
      showError(validationResult)
    }
    try {
      await context.api.dashboardService.saveDashboardItem(input)
    } catch (e) {
      dispatch({ type: actionTypes.Error })
    }
  }

  const deleteDashboardItem = (id) => {
    dispatch({ type: actionTypes.Updating })
    context.api.dashboardService.deleteDashboardItem(id)
      .then(() => {
        dispatch({ type: actionTypes.Updated })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  }

  const handleOnAddButtonClick = () => {
    openDialog({
      dialogType: dialogTypes.addDashboardWidget,
      primaryButtonText: 'Common.SaveAndClose',
      onAction: (details) => {
        const input = {
          id: 0,
          rowsCount: Number(details.rowsCount),
          order: 0,
          widgetType: details.widgetType
        }
        saveDashboardItem(input)
      },
      localize
    })
  }

  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Common.DashboardWidgetsTitle' /></MainTopTitle>
        <MainTopLeft>
          <Button disabled={state.fetching || state.updating || !state.canAddWidget} size='sm' color='primary' onClick={handleOnAddButtonClick}>
            <Icon name='plus' /> <span><Resx name='Common.AddWidget' /></span>
          </Button>
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <DashboardList
          localize={localize}
          dashboard={state}
          enumName={enumName}
          saveDashboardItem={saveDashboardItemSilent}
          deleteDashboardItem={deleteDashboardItem} />
      </MainBody>
    </Main>
  )
}

export default DashboardSettings



// WEBPACK FOOTER //
// ./src/components/dashboard/settings/page.js